// @vendors
const get = require('lodash/object/get');
const moment = require('moment');

// @utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');

// @constants
const { DATE_FORMAT_API } = require('constants/index');
const {
    BROKER_CONTRACT_ACTIVITIES_DATE_LIMIT_YEARS_FROM_NOW,
    BROKER_CONTRACT_VALUE_TYPE
} = require('constants/index');

// @contact_center
const {
    BROKER_GET_CONTRACT_STATUS_REQUEST,
    BROKER_GET_CONTRACT_STATUS_SUCCESS,
    BROKER_GET_CONTRACT_STATUS_FAILURE,
    BROKER_GET_CONTRACT_RESET
} = require('constants/contactCenter/actionTypes');
const { PENDING } = require('constants/contactCenter/brokerContractState');

const DATE_LIMIT = moment()
    .subtract(BROKER_CONTRACT_ACTIVITIES_DATE_LIMIT_YEARS_FROM_NOW, 'years')
    .format(DATE_FORMAT_API); // This is a limit in the API endpoint
const DATE_FROM = moment()
    .startOf('day')
    .subtract('2', 'weeks')
    .format(); // logic inherited from brokerContractActivities
const DATE_TO = moment()
    .startOf('day')
    .format();

const setContractReset = () => ({
    type: BROKER_GET_CONTRACT_RESET
});

const getContractStateFetching = payload => ({
    type: BROKER_GET_CONTRACT_STATUS_REQUEST,
    payload
});

const getContractStateSuccess = payload => ({
    type: BROKER_GET_CONTRACT_STATUS_SUCCESS,
    payload
});

const getContractStateFailure = payload => ({
    type: BROKER_GET_CONTRACT_STATUS_FAILURE,
    payload
});

const getStatePendingInContract = (res = {}) => {
    let hasPending = false;

    if (get(res, 'listaOrdenes.orden')) {
        res.listaOrdenes.orden.forEach(order => {
            if (get(order, 'situacionOrden')) {
                if (order.situacionOrden.trim() === PENDING) {
                    hasPending = true;
                }
            }
        });
    }

    return hasPending;
};

const getContractState = immStocksContracts => dispatch => {
    dispatch(setContractReset());

    const immContractsValueType = immStocksContracts.filter(immContract => {
        const typeContract = immContract.get('tipoContrato');
        return typeContract && typeContract.trim() == BROKER_CONTRACT_VALUE_TYPE;
    });

    immContractsValueType.forEach(immContract => {
        const immProducts = immContract.get('elements');

        if (immProducts.size > 0) {
            const contractId = immContract.get('contract');
            const product = immProducts.getIn(['0', 'producto']);
            const numberContract = immProducts.getIn(['0', 'numerodecontrato']);
            let requestData = {
                query: {
                    producto: product,
                    numeroContrato: numberContract
                }
            };
            // logic inherited from brokerContractActivities
            const dateFromValid = moment(DATE_FROM || DATE_LIMIT).isAfter(DATE_LIMIT);
            const dateToValid = moment(DATE_TO).isAfter(DATE_LIMIT);

            requestData.query.fechaDesde = dateFromValid
                ? moment(DATE_FROM).format(DATE_FORMAT_API)
                : DATE_LIMIT;
            requestData.query.fechaHasta = dateToValid
                ? moment(DATE_TO).format(DATE_FORMAT_API)
                : DATE_LIMIT;

            dispatch(
                getContractStateFetching({
                    contractId
                })
            );

            return APIGet(dispatch, apiURLBuilder.getURL('contractValueActivities'), requestData)
                .then(res => {
                    dispatch(
                        getContractStateSuccess({
                            contractId,
                            numberContract,
                            hasPending: getStatePendingInContract(res)
                        })
                    );
                })
                .catch(() => {
                    dispatch(
                        getContractStateFailure({
                            contractId,
                            numberContract
                        })
                    );
                });
        }
    });
};

module.exports = {
    getContractState
};
